<script setup lang="ts">
import MdiFaIcon from '../MdiFaIcon.vue';
import useLocale from '../helpers/use-locale';

type Emits = {
  (e: 'click'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  isTouchDevice?: boolean;
};
withDefaults(defineProps<Props>(), {
  isTouchDevice: false,
});
const { t } = useLocale();
</script>

<template>
  <v-btn
    variant="text"
    class="ml-1 ctrl-btn"
    size="48"
    :color="'currentColor'"
    :aria-label="t('components.label_additional')"
    @click="emit('click')"
  >
    <MdiFaIcon icon="fa-solid fa-ellipsis" size="medium" />
    <v-tooltip
      :disabled="isTouchDevice"
      :text="t('components.label_additional')"
      activator="parent"
      location="top"
      aria-hidden="true"
    />
    <slot></slot>
  </v-btn>
</template>

<style scoped lang="scss"></style>
